<nz-table
  nzShowSizeChanger
  #nzTable
  [nzData]="loadData()"
  [nzFrontPagination]="false"
  [nzLoading]="loader()"
  [nzTotal]="total()"
  [nzPageSize]="pageSize()"
  [nzPageIndex]="page()"
  [nzVirtualForTrackBy]="trackByIndex"
  (nzQueryParams)="paginatorChange($event)"
  [nzPageSizeOptions]="[5, 10, 20, 50, 100]"
  nzSize="small"
  nzTableLayout="auto"
  [nzScroll]="{ x: '84vw' }"
  >
  <thead>
    <tr>
      <th nzWidth="40px" nzRight></th>
      <th nzWidth="200px">{{ 'users.column.service' | translate }}</th>
      <th>{{ 'users.column.price' | translate }}</th>
      <th>{{ 'users.column.reservationTime' | translate }}</th>
      <th>{{ 'users.column.startingTime' | translate }}</th>
      <th>{{ 'users.column.finishingTime' | translate }}</th>
      <th>{{ 'users.column.employee' | translate }}</th>
      <th>{{ 'users.column.description' | translate }}</th>
      <th>კომენტარი</th>
      <th>{{ 'users.column.created' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    @for (row of nzTable.data; track row; let i = $index) {
      <tr>
        <td nzRight
          [nzExpand]="expandSet.has(row.id)"
          (nzExpandChange)="onExpandChange(row.id, $event)"
        ></td>
        <td>
          @let services = row?.bookingServices || row?.services;
          @if (row.visitId) {
            <!--                  {{ services?.map((s) => s.name).join(', ') }}-->
            @for (service of services; track service.id) {
              <span [nz-tooltip]="service?.service?.name">{{ service?.service?.name }}</span>
              @if (isPackageService(service)) {
                <nz-tag
                  nzColor="blue"
                  class="ml-1"
                  [nz-tooltip]="'services.packages.coveredByPackage' | translate"
                >
                  <span nz-icon nzType="gift" nzTheme="outline"></span>
                  {{ service?.packageName || ('services.packages.packageName' | translate) }}
                </nz-tag>
              }
            }
          } @else {
            {{ row?.service?.name }}
          }
        </td>
        <td>{{ row?.price }}</td>
        <td>{{ row?.bookingDate | date: 'dd/MM/yyyy' }}</td>
        <td>{{ row?.startTime }}</td>
        <td>{{ row?.endTime }}</td>
        <td>{{ row?.employee?.user?.firstname }} {{ row?.employee?.user?.lastname }}</td>
        <td>
          <span
            nz-popover
            nzPopoverTitle="დიაგნოზი"
            [nzPopoverContent]="row?.description"
          >{{ row?.description }}</span>
        </td>
        <td>
          @if (row?.latestComment?.text) {
            <span class="flex items-center gap-1" [nz-tooltip]="row?.latestComment?.text">
              @if (row?.latestComment?.isPinned) {
                <i nz-icon nzType="pushpin" nzTheme="fill" style="color: #1890ff;"></i>
              }
              {{ row?.latestComment?.text }}
            </span>
          }
        </td>
        <td>{{ row?.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
      </tr>
      <tr [nzExpand]="expandSet.has(row.id)">
        <td colspan="10">
          @if (row.visitId) {
            @for (service of row?.bookingServices; track service.id) {
              <nz-tag
                [nzColor]="isPackageService(service) ? 'blue' : 'default'"
                [nz-tooltip]="isPackageService(service) ? ('services.packages.coveredByPackage' | translate) : service?.service?.name"
              >
                @if (isPackageService(service)) {
                  <span nz-icon nzType="gift" nzTheme="outline"></span>
                }
                {{ service?.service?.name }}
                @if (isPackageService(service) && service?.packageName) {
                  · {{ service?.packageName }}
                }
              </nz-tag>
            }
          } @else {
            @for (service of row?.services; track service) {
              <nz-tag
                [nz-tooltip]="service?.description"
                >{{ service?.service?.name }}
              </nz-tag>
            }
          }
        </td>
      </tr>
    }
  </tbody>
</nz-table>
